/**
 * Utilidades para el control determinista de la barra lateral (SideNav / PushMenu)
 * Soporta responsive, AdminLTE y navegacion SPA de React.
 */

export const isSidebarOpen = () => {
  const body = document.body;
  if (window.innerWidth < 992) {
    return body.classList.contains('sidebar-open');
  }
  return !body.classList.contains('sidebar-collapse');
};

export const cerrarSidebar = () => {
  const body = document.body;
  if (window.innerWidth < 992) {
    body.classList.remove('sidebar-open');
    body.classList.add('sidebar-closed', 'sidebar-collapse');
  } else {
    body.classList.add('sidebar-collapse');
  }
  const overlay = document.querySelector('#sidebar-overlay');
  if (overlay) {
    overlay.style.display = 'none';
  }
};

export const abrirSidebar = () => {
  const body = document.body;
  if (window.innerWidth < 992) {
    body.classList.remove('sidebar-closed', 'sidebar-collapse');
    body.classList.add('sidebar-open');
    const overlay = document.querySelector('#sidebar-overlay');
    if (overlay) {
      overlay.style.display = 'block';
    }
  } else {
    body.classList.remove('sidebar-collapse');
  }
};

export const toggleSidebar = (e) => {
  if (e) {
    if (typeof e.preventDefault === 'function') e.preventDefault();
    if (typeof e.stopPropagation === 'function') e.stopPropagation();
  }

  if (isSidebarOpen()) {
    cerrarSidebar();
  } else {
    abrirSidebar();
  }
};
